import { Option } from '../../types/mold';
import { locationStorageService, injectionMachineService, moldService, customerService, moldOrderService } from '../../services/api';
import { getErrorCodeList, getRootCausesList } from '../../constants/errorCode';

// Type for fetch functions that return options
export type OptionsFetcher = () => Promise<Option[]>;

// Registry of available fetcher functions by ID
const fetchersRegistry: Record<string, OptionsFetcher> = {
  // Location fetchers
  'locationStorage': locationStorageService.getAll,
  
  // Machine fetchers
  'injectionMachine': injectionMachineService.getOptions,

  'moldType': moldService.getMoldTypes,

  'plateType': moldService.getPlateTypes,

  'gateType': moldService.getGateTypes,

  'mold.surfaceFinish': moldService.getSurfaceFinishOptions,

  'mold.insertChangeType': moldService.getInsertChangeTypeOptions,

  'spring.allColors': moldService.getSpringColors,

  'mold.allCountries': moldService.getCountryList,

  'mold.mcSizeList': moldService.getMcSizeList,

  /** Customize list for SBI */
  'mold.moldSourceList': moldService.getSBIMoldSourceOptions,
  
  'mold.generic.moldSourceList': moldService.getMoldSourceOptions,

  'mold.hotRunnerTypeList': moldService.getHotRunnerTypeOptions,

  'mold.partMatGradeList': moldService.getPartMatGradeOptions,

  'mold.exportRootCausesList': () => Promise.resolve([
    { value: 'คืนลูกค้า', label: 'คืนลูกค้า' },
    { value: 'ทำลาย', label: 'ทำลาย' },
    { value: 'ยืม supplier', label: 'ยืม supplier' },
    { value: 'EOL', label: 'EOL' },
  ]),

  'customer.getOptions': customerService.getOptions,

  'moldOrder.notes': moldOrderService.getNotesOptions,

  'errorCodeList': getErrorCodeList,

  'rootCausesList': getRootCausesList,

  'repairProblemDuringList': () => Promise.resolve([
    { value: 'การผลิต', label: 'การผลิต' },
    { value: 'การทดลอง', label: 'การทดลอง' },
    { value: 'ปรับตั้ง', label: 'ปรับตั้ง' },
    { value: 'QA ให้ทำการแก้ไข', label: 'QA ให้ทำการแก้ไข' },
    { value: 'จบ LOT การแก้ไข', label: 'จบ LOT การแก้ไข' },
  ]),

  'repairRootCausesList': () => Promise.resolve([
    { value: 'แม่พิมพ์เสีย', label: 'แม่พิมพ์เสีย' },
    { value: 'ชิ้นงานมีปัญหา', label: 'ชิ้นงานมีปัญหา' },
    { value: 'ลูกค้าขอให้ซ่อม', label: 'ลูกค้าขอให้ซ่อม' },
    { value: 'ซ่อมหรือสร้างอื่นๆ', label: 'ซ่อมหรือสร้างอื่นๆ' },
  ]),

  'repairModifyCausesList': () => Promise.resolve([
    { value: 'ลูกค้าขอให้ modify', label: 'ลูกค้าขอให้ modify' },
    { value: 'SK ขอให้ modify', label: 'SK ขอให้ modify' },
  ]),
  
  // Add more fetchers as needed based on what's available in your services
};

/**
 * Gets a fetch function by its identifier
 * @param fetcherId The identifier for the fetcher
 * @returns The fetch function or undefined if not found
 */
export const getFetcher = (fetcherId: string | undefined): OptionsFetcher | undefined => {
  if (!fetcherId) return undefined;
  return fetchersRegistry[fetcherId];
};

/**
 * Registers a new fetcher or overrides an existing one
 * @param fetcherId The identifier for the fetcher
 * @param fetcher The fetch function
 */
export const registerFetcher = (fetcherId: string, fetcher: OptionsFetcher): void => {
  fetchersRegistry[fetcherId] = fetcher;
};

export default fetchersRegistry;
